"use client";

import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function Terms() {
  const {
    ref: heroRef,
    isVisible: heroVisible
  } = useRevealOnScroll<HTMLDivElement>({
    threshold: 0.1
  });
  const {
    ref: imgRef,
    isVisible: imgVisible
  } = useRevealOnScroll<HTMLDivElement>({
    threshold: 0.2
  });
  const {
    ref: contentRef,
    isVisible: contentVisible
  } = useRevealOnScroll<HTMLDivElement>({
    threshold: 0.15
  });
  return <section data-section-id="586" id="termsandconditions" className="relative bg-background text-foreground">
      {}
      <div ref={heroRef} className="relative w-full h-[60vh] min-h-[480px] overflow-hidden">
        <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1717971/img/cyber_security_infrastructure.webp" alt="Advanced digital security infrastructure and network protection" loading="lazy" decoding="async" className="absolute inset-0 w-full h-full object-cover" />
        {}
        <div className="absolute inset-0 bg-blue-950/70 mix-blend-multiply" />
        <div className="absolute inset-0 bg-gradient-to-b from-blue-950/30 via-transparent to-background" />

        {}
        <div className={`relative z-10 h-full flex flex-col items-center justify-center px-6 text-center transition-all duration-1000 ease-out ${heroVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-6"}`}>
          <span className="font-default text-xs sm:text-sm tracking-[0.3em] uppercase text-blue-100/85 mb-6">
            Legal Framework
          </span>
          <h1 className="font-default font-bold text-white text-4xl sm:text-6xl md:text-7xl lg:text-8xl leading-[1.05] max-w-5xl tracking-tight">
            Terms and Conditions of Service
          </h1>
        </div>
      </div>

      {}
      <div className="bg-background px-6 sm:px-10 lg:px-20 py-24 md:py-32 lg:py-40">
        <div className="max-w-7xl mx-auto grid grid-cols-1 lg:grid-cols-12 gap-12 lg:gap-16 items-start">
          {}
          <div ref={imgRef} data-index={0} className={`lg:col-span-5 lg:sticky lg:top-24 transition-all duration-1000 ease-out ${imgVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`}>
            <div className="relative lg:-mt-32 lg:ml-4">
              <div className="overflow-hidden rounded-lg shadow-lg bg-card">
                <div className="aspect-[3/4] w-full">
                  <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1717971/img/security_compliance_audit.png" alt="Professional security compliance audit and documentation" loading="lazy" decoding="async" className="w-full h-full object-cover" />
                </div>
              </div>
              <p className="mt-4 font-default text-xs uppercase tracking-[0.25em] text-muted-foreground">
                InfinitySecure &mdash; Compliance Standards
              </p>
            </div>
          </div>

          {}
          <div ref={contentRef} className={`lg:col-span-7 transition-all duration-1000 ease-out delay-150 ${contentVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`}>
            <span className="font-default text-xs uppercase tracking-[0.3em] text-blue-600">
              Updated 2026 &middot; Legal Notice
            </span>

            <div className="mt-8 space-y-7 font-default text-foreground/90 leading-[1.7] text-xl">
              <p className="first-letter:font-default first-letter:text-[5.5rem] first-letter:leading-[0.85] first-letter:font-bold first-letter:text-blue-600 first-letter:float-left first-letter:mr-3 first-letter:mt-2">
                InfinitySecure provides advanced cybersecurity solutions designed to protect your digital assets. By accessing our services, you agree to comply with these terms, which govern our professional relationship, data handling practices, and the scope of our security monitoring and incident response protocols. We are committed to transparency and excellence in every engagement.
              </p>

              <p>
                Our services include AI-driven threat detection, 24/7 security monitoring, and proactive risk management. Clients are responsible for maintaining the confidentiality of their access credentials and ensuring that their internal systems are prepared for the security measures we implement. We operate under strict confidentiality agreements to ensure your business data remains secure.
              </p>

              {}
              <blockquote className="relative pl-8 my-12 border-l-2 border-blue-500">
                <p className="font-default italic text-blue-700 text-2xl md:text-[28px] leading-[1.4] font-semibold">
                  &ldquo;Security is not a static goal, but a continuous process of vigilance, adaptation, and partnership between our experts and your business.&rdquo;
                </p>
              </blockquote>

              <p>
                InfinitySecure maintains global standards for compliance and risk mitigation. Our incident response teams are available to assist in the event of a security breach, provided that the client has maintained the agreed-upon security configurations. We reserve the right to update our protocols to address emerging cyber threats in real-time.
              </p>

              <p>
                By utilizing our platform, you acknowledge that cybersecurity involves inherent risks and that InfinitySecure acts as a proactive partner in minimizing these threats. We strive for 100% uptime and protection, ensuring your organization remains resilient against modern digital attacks.
              </p>
            </div>

            {}
            <div className="mt-14 pt-10 border-t border-border">
              <div className="mt-4">
                <p className="font-default text-lg font-bold text-foreground">InfinitySecure Legal Team</p>
                <p className="font-default text-xs uppercase tracking-[0.25em] text-muted-foreground mt-1">
                  Compliance Department &middot; InfinitySecure
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>;
}